import { DesignTokens } from "../../types"

export const createHeadingFontSizes: (
  foundation: DesignTokens.Foundation,
  contextual: DesignTokens.Contextual,
) => DesignTokens.HeadingFontSizes = (foundation, { fontSizes }) => ({
  level1: fontSizes.xxxxLarge,
  level2: fontSizes.xxxLarge,
  level3: fontSizes.xxLarge,
  level4: fontSizes.xLarge,
  level5: fontSizes.large,
  level6: fontSizes.medium,
})

export const createHeadingLineHeights: (
  foundation: DesignTokens.Foundation,
  contextual: DesignTokens.Contextual,
) => DesignTokens.HeadingLineHeights = (foundation, { lineHeights }) => ({
  level1: lineHeights.xxLarge,
  level2: lineHeights.xLarge,
  level3: lineHeights.large,
  level4: lineHeights.large,
  level5: lineHeights.large,
  level6: lineHeights.medium,
})
